export const userChangePrice = {
  goDetail: 'n.5167.10801.0',
  ssuSelect: 'n.5167.10802.0',
  changeBtnClick: 'n.5167.10803.0',
  goodAdd: 'n.5167.10804.0',
  goodExpose: 'n.5167.10805.0'
}
